import { useLang } from "@/lib/LanguageContext";

export default function Process() {
    const { t } = useLang();

    return (
        <section
            data-testid="process-section"
            className="py-20 lg:py-32 bg-navy text-ivory relative overflow-hidden"
        >
            <div className="mx-auto max-w-screen-2xl px-6 md:px-12 lg:px-20 relative">
                <div className="grid grid-cols-12 gap-8 md:gap-16 mb-16">
                    <div className="col-span-12 md:col-span-6">
                        <p className="overline text-terracotta mb-6">
                            {t.process.eyebrow}
                        </p>
                        <h2 className="font-serif text-5xl lg:text-7xl font-light tracking-tight text-ivory">
                            {t.process.title}
                        </h2>
                    </div>
                    <p className="col-span-12 md:col-span-6 self-end max-w-xl text-ivory/70 leading-relaxed">
                        {t.process.subtitle}
                    </p>
                </div>

                <ol className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-y-12 lg:gap-y-0 border-t border-ivory/15">
                    {t.process.steps.map((step, idx) => (
                        <li
                            key={step.n}
                            data-testid={`process-step-${step.n}`}
                            className={`pt-8 lg:pt-10 lg:pr-8 ${
                                idx !== 0 ? "lg:border-l border-ivory/15 lg:pl-8" : ""
                            }`}
                        >
                            <div className="flex items-center gap-4 mb-6">
                                <span className="font-serif italic text-terracotta text-2xl">
                                    {step.n}
                                </span>
                                <span className="block flex-1 h-px bg-ivory/20" />
                            </div>
                            <h3 className="font-serif text-3xl font-light text-ivory mb-4 leading-tight">
                                {step.title}
                            </h3>
                            <p className="text-ivory/65 leading-relaxed">
                                {step.body}
                            </p>
                        </li>
                    ))}
                </ol>
            </div>
        </section>
    );
}
